import React, { useState } from "react";
import FeatureSection from "../Components/Landing/FeatureSection";
import HeroSection from "../Components/Landing/HeroSection";
import Footer from "../Components/Landing/LandingFooter";
import Navbar from "../Components/Landing/LandingNavbar";
import { CtaSection, HowItWorksSection, IntegrationsSection, PricingSection, SolutionsSection } from "../Components/Landing/ProductSections";
import { DARK_COLORS, FONTS, LIGHT_COLORS, MEDIA_URL } from "../Components/Landing/landingTheme";

const featureIconStyle = { width: "42px", height: "42px", objectFit: "contain", filter: "brightness(0) invert(1)" };

const pinballIcon = <img src="/icons/pinball.png" alt="Pinball" style={featureIconStyle} />;
const ticketIcon = <img src="/icons/tickets.png" alt="Tickets" style={featureIconStyle} />;
const wheelIcon = <img src="/icons/console.png" alt="Console" style={featureIconStyle} />;

/* ─────────────────────── MAIN PAGE ─────────────────────── */
export default function HomePage({ darkMode, setDarkMode }) {
    const colors = darkMode ? DARK_COLORS : LIGHT_COLORS;
    const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);

    // Os modais vivem no hero (topo); rola até ele de onde estiver
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    const openAuth = () => { scrollToTop(); setIsContactModalOpen(false); setIsAuthModalOpen(true); };
    const openContact = () => { scrollToTop(); setIsAuthModalOpen(false); setIsContactModalOpen(true); };
    const scrollToSection = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

    const tradingCards = [
        { text: "PINBALLS", bgColor: colors.primaryLight, videos: [`${MEDIA_URL}/Pinball.mp4`], icon: pinballIcon },
        { text: "REDEMPTIONS", bgColor: colors.secondaryDeep, videos: [`${MEDIA_URL}/Rendaption.mp4`], icon: ticketIcon },
        { text: "SIMULATORS", bgColor: colors.bg, videos: [`${MEDIA_URL}/Simulador.mp4`], icon: wheelIcon },
    ];

    const tradingIcon = (
        <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke={colors.textDark} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 18H3.76C4.55 18 5.32 17.68 5.88 17.12L15.12 7.88C15.68 7.32 16.45 7 17.24 7H19M3 6H3.76C4.55 6 5.32 6.32 5.88 6.88L8 9M19 17H17.24C16.45 17 15.68 16.68 15.12 16.12L14 15M18 4L21 7L18 10M18 14L21 17L18 20" /></svg>
    );

    return (
        <div style={{
            width: "100%", minHeight: "100vh", background: colors.bg, fontFamily: FONTS.body, overflowX: "clip", position: "relative",
        }}>
            <style>{`
                *::-webkit-scrollbar { display: none; }
                * { -ms-overflow-style: none; scrollbar-width: none; }
                body, html { margin: 0; padding: 0; width: 100%; background: ${colors.bg}; }
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
                @font-face {
                    font-family: 'Marine Sikona';
                    src: url('/fonts/Marine Sikona.otf') format('opentype');
                    font-weight: normal;
                    font-style: normal;
                }
                @font-face {
                    font-family: 'BoldFont';
                    src: url('/fonts/bold.otf') format('opentype');
                    font-weight: normal;
                    font-style: normal;
                }
            `}</style>

            <Navbar colors={colors} darkMode={darkMode} setDarkMode={setDarkMode} onOpenAuth={openAuth} onOpenContact={openContact} onNavigate={scrollToSection} />

            <HeroSection
                colors={colors}
                onOpenAuth={openAuth}
                isAuthModalOpen={isAuthModalOpen}
                onCloseAuth={() => setIsAuthModalOpen(false)}
                onOpenContact={openContact}
                isContactModalOpen={isContactModalOpen}
                onCloseContact={() => setIsContactModalOpen(false)}
            />

            <FeatureSection colors={colors} title={"Menos tempo de máquina parada,\nmais rentabilidade para o negócio."} logoColor={colors.primaryMain} sectionLabel="Equipamentos" sectionIcon={tradingIcon} cards={tradingCards} />

            <SolutionsSection colors={colors} darkMode={darkMode} />

            <HowItWorksSection colors={colors} darkMode={darkMode} />

            <IntegrationsSection colors={colors} darkMode={darkMode} />

            <PricingSection colors={colors} darkMode={darkMode} onOpenAuth={openAuth} />

            <CtaSection colors={colors} darkMode={darkMode} onOpenAuth={openAuth} onOpenContact={openContact} />

            <Footer colors={colors} onOpenContact={openContact} />
        </div>
    );
}
